import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeLeave  {
    _originalTypeClassName = "zSHR.BO.EmployeeLeave";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeLeave.translate = translateService;
}
this.LeaveTypes = [];
this.Id = null;
this.Year = null;
this.TotalDays = null;
this.RequestedDays = null;
this.ApprovedDays = null;
this.RemaingDays = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Year:any;
TotalDays:any;
RequestedDays:any;
ApprovedDays:any;
RemaingDays:any;
LeaveTypes:any;
EmployeeContract:any;
static setLeaveTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveTypes.length > 0) {
                    Domain.EmployeeLeave.removeLeaveTypes($this, $this.LeaveTypes[0]);
                }

                Domain.EmployeeLeave.addManyLeaveTypes($this, copyItems);
            }
static addManyLeaveTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeLeave.addLeaveTypes($this, items[i]);
                }
            }
static addLeaveTypes = ($this, item) => {
                if ($this.LeaveTypes == null) $this.LeaveTypes = [];
                if (item == null || $this.LeaveTypes.indexOf(item) > -1) return;
                $this.LeaveTypes.push(item);
}
static addRangeLeaveTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeLeave.addLeaveTypes($this, item));
            }
static removeLeaveTypes = ($this, item) => {
                if ($this == null || $this.LeaveTypes == null || $this.LeaveTypes.indexOf(item) === -1) return;
                var _index = $this.LeaveTypes.indexOf(item);
                $this.LeaveTypes.splice(_index, 1);
}
static clearLeaveTypes = ($this) => { $this.LeaveTypes = null; }
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}